// import { Component, OnInit } from '@angular/core';
// import { NbDialogRef } from '@nebular/theme';
// import { Router } from '@angular/router';
// import { NotificationService } from '../../../../services/notification/notification.service';

// @Component({
//   selector: 'app-notifications-modal',
//   templateUrl: './notifications-modal.component.html',
//   styleUrls: ['./notifications-modal.component.scss'],
// })
// export class NotificationsModalComponent implements OnInit {

//   notifications: any[] = [];
//   activeTab: 'all' | 'archived' = 'all';
//   unreadCount = 0;

//   constructor(
//     private dialogRef: NbDialogRef<NotificationsModalComponent>,
//     private router: Router,
//     private notificationService: NotificationService   // ✅ Added
//   ) {}

//   ngOnInit(): void {
//     this.loadNotifications();   // ✅ load JSON instead of mock
//   }

//   loadNotifications() {
//     this.notificationService.getNotifications().subscribe({
//       next: (res) => {
//         this.notifications = res.data;

//         // Count unread
//         this.unreadCount = this.notifications.filter(n => !n.read).length;
//       },
//       error: (err) => {
//         console.error('Failed to load notifications', err);
//       }
//     });
//   }

//   getIconForType(type: string): string {
//     switch (type) {
//       case 'success': return 'checkmark-circle-2-outline';
//       case 'danger': return 'close-circle-outline';
//       case 'warning': return 'alert-triangle-outline';
//       case 'info': return 'info-outline';
//       default: return 'bell-outline';
//     }
//   }

//   markAllAsRead() {
//     this.notifications.forEach(n => n.read = true);
//     this.unreadCount = 0;
//   }

//   close() {
//     this.dialogRef.close();
//   }

//   onNotificationClick(notification: any) {
//     console.log('Notification clicked:', notification);

//     this.close();
//     this.router.navigate(['/pages/notifications']);
//   }
// }


import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { Router } from '@angular/router';
import { NotificationService } from '../../../../services/notification/notification.service';

@Component({
  selector: 'app-notifications-modal',
  templateUrl: './notifications-modal.component.html',
  styleUrls: ['./notifications-modal.component.scss'],
})
export class NotificationsModalComponent implements OnInit {

  notifications: any[] = [];
  activeTab: 'all' | 'archived' = 'all';
  unreadCount = 0;

  constructor(
    private dialogRef: NbDialogRef<NotificationsModalComponent>,
    private router: Router,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.loadNotifications();
  }

  loadNotifications() {
    this.notificationService.getNotifications().subscribe({
      next: (res) => {
        this.notifications = res.data;
        this.unreadCount = this.notifications.filter(n => !n.read).length;
      },
      error: (err) => {
        console.error('Failed to load notifications', err);
      }
    });
  }

  getIconForType(type: string): string {
    switch (type) {
      case 'success': return 'checkmark-circle-outline';
      case 'danger': return 'close-circle-outline';
      case 'warning': return 'alert-triangle-outline';
      case 'info': return 'info-outline';
      default: return 'bell-outline';
    }
  }

  formatTimestamp(createdAt: string): string {
    const date = new Date(createdAt);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric'
    });
  }

  // markAllAsRead() {
  //   this.notificationService.markAllAsRead().subscribe({
  //     next: () => {
  //       this.notifications.forEach(n => n.read = true);
  //       this.unreadCount = 0;
  //     },
  //     error: (err) => console.error('Failed to mark all as read', err)
  //   });
  // }

  close() {
    this.dialogRef.close();
  }

  onNotificationClick(notification: any) {
    console.log('Notification clicked:', notification);

    if (!notification.read) {
      this.notificationService.markAsRead(notification.id).subscribe({
        next: () => {
          notification.read = true;
          this.unreadCount = this.notifications.filter(n => !n.read).length;
        }
      });
    }

    this.close();
    this.router.navigate(['/pages/notifications']);
  }
}